import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hips': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M251.6 157.6v201.8c0 1.9-0.9 2.8-2.8 2.8h-40.9c-1.6 0-2.7-1.4-2.7-2.8v-201.8c0-1.4 1.1-2.8 2.7-2.8h40.9c1.9 0 2.8 0.9 2.8 2.8zM156.5 168c18.7 13.5 28 31.9 28 55.3v136.1c0 1.9-0.9 2.8-2.7 2.8h-27.3c-9.1 0-16.4-7.3-16.4-16.3v-122.6c0-0.9 2.7-27-45.8-27-48.6 0-45.8 26.2-45.8 27v136.1c0 1.9-0.9 2.8-2.8 2.8h-41c-1.8 0-2.7-0.9-2.7-2.8v-279.2c0-1.8 0.9-2.7 2.7-2.7h40.9c1.9 0 2.8 0.9 2.8 2.7v81.2c15.2-7.7 31.7-11.5 49.8-11.4 24 0.1 44.2 6.2 60.3 18zM634.9 278.1c5.5 12.6 6.6 25.6 3.1 39.1-9.6 36.9-44.9 45.5-45.6 45.8-10.5 3.1-23.6 4.3-36.3 4.3-16.6 0-32.6-2.7-48.2-8.2-9.7-3.4-14.6-10.3-14.6-20.7v-34.4c0-2.1 2.3-3.7 4.4-2.3 13.7 10.2 34.1 19.1 58.4 19.1 23.3 0 32.8-4.5 36.5-13.6 3-7.9-0.6-16.1-12.2-21.2l-53.6-23.5c-21.4-9.4-33.8-24-37.2-43.6-5.7-33.7 22.2-53.3 22.7-53.7 13.2-9.6 32-15.4 58.5-15.4 19 0 37.4 3.3 55.1 9.9 1.3 0.5 1.9 1.3 1.9 2.6v44.7c0 2.1-2.3 3.4-4 2.4-39.7-20.7-76.6-12.3-84-6.8-6.6 4.9-6 12.5 2.6 16.1l57.6 25.3c16.5 7.1 28.1 18.4 34.9 34.1zM376.2 149.8c60.4 0 108.7 48.3 108.6 108.6 0 60.2-48.2 108.7-108.7 108.7-21.9 0-41.2-6.4-57.7-19.1v88.8c0 1.8-0.9 2.7-2.8 2.7h-40.9c-2.1 0-2.7-1.9-2.7-2.7v-183.5c0-83.4 72.5-103.5 104.2-103.5zM376.2 320.7c34.9 0 62.3-27.9 62.2-62.2 0-34.6-27.7-62.2-62.2-62.2-34.6 0-62.2 27.7-62.2 62.2 0 17.2 6 31.8 18.2 44 12.1 12.1 26.8 18.2 44 18.2zM228.3 72.5c15.9 0 28.9 12.7 28.9 28.9 0 15.8-12.7 28.9-28.9 28.9s-28.9-13.3-28.9-28.9c0.1-16 13-28.9 28.9-28.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hips.js
// module id = 877
// module chunks = 0